export default __webpack_public_path__ + "static/media/school.35638110.svg";